// Экран выбора варианта упражнения для студента. Отображает выпадающий список доступных вариантов с историей прохождения.

import { useState } from 'react';
import {
  Container, Card, Button, Badge, Form,
} from 'react-bootstrap';
import AppNavbar from '../../common/AppNavbar';

function variantOptionLabel(v, idx) {
  const label = `Вариант ${v.variant ?? idx + 1}`;
  return { label };
}

function variantStatusBadge(hist) {
  if (hist?.status === 1) {
    const label = hist.score_percent != null
      ? `Пройден · ${hist.score_percent}%`
      : 'Пройден';
    return <Badge bg="success" style={{ fontSize: '0.75rem', fontWeight: 600 }}>{label}</Badge>;
  }
  if (hist?.status === 0) {
    return <Badge bg="warning" text="dark" style={{ fontSize: '0.75rem', fontWeight: 600 }}>Не завершён</Badge>;
  }
  return <Badge bg="light" text="dark" style={{ fontSize: '0.75rem', fontWeight: 600, border: '1px solid #dee2e6' }}>Не начат</Badge>;
}

export default function StudentVariantSelectScreen({
  exercise,
  variants,
  onSelect,
  onBack,
  variantHistoryMap,
  preSelectedVariantId,
}) {
  const [selected, setSelected] = useState(preSelectedVariantId ?? variants[0]?.id ?? null);

  const selectedIdx = variants.findIndex((v) => v.id === selected);
  const selectedVariant = selectedIdx !== -1 ? variants[selectedIdx] : null;
  const selectedHist = selectedVariant ? variantHistoryMap?.[selectedVariant.id] : null;
  const startLabel = selectedVariant
    ? `Начать · Вариант ${selectedVariant.variant ?? selectedIdx + 1}`
    : 'Начать';

  return (
    <>
      <AppNavbar />
      <div style={{ background: 'var(--ewl-bg-body)', minHeight: 'calc(100vh - 56px)' }}>
        <Container className="py-4" style={{ maxWidth: 680 }}>
          <div className="mb-4">
            <Button
              variant="link"
              size="sm"
              onClick={onBack}
              style={{ padding: 0, color: '#6c757d', textDecoration: 'none', fontWeight: 500, fontSize: '0.875rem' }}
            >
              ← К упражнениям
            </Button>
          </div>

          <div className="mb-4">
            <h5
              className="fw-bold mb-1"
              style={{ letterSpacing: '-0.01em', color: '#1e2a4a', lineHeight: 1.35 }}
            >
              {exercise.name}
            </h5>
            {exercise.task && (
              <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
                {exercise.task}
              </p>
            )}
          </div>

          <p style={{ fontSize: '0.8rem', color: '#6c757d', marginBottom: '0.75rem' }}>
            Выберите вариант из списка, затем нажмите «Начать»
          </p>

          <h6 className="fw-semibold mb-3" style={{ color: '#1e2a4a' }}>
            Выберите вариант
          </h6>

          <Form.Group className="mb-4">
            <Form.Select
              value={selected ?? ''}
              onChange={(e) => setSelected(Number(e.target.value))}
              style={{
                borderRadius: '0.75rem',
                border: '1px solid #e9ecef',
                padding: '0.75rem 1rem',
                fontSize: '0.9rem',
                fontWeight: 500,
                color: '#1e2a4a',
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              }}
            >
              {variants.map((v, idx) => {
                const { label } = variantOptionLabel(v, idx);
                const hist = variantHistoryMap?.[v.id];
                let statusText = 'не начат';
                if (hist?.status === 1) {
                  statusText = hist.score_percent != null ? `пройден · ${hist.score_percent}%` : 'пройден';
                } else if (hist?.status === 0) {
                  statusText = 'не завершён';
                }
                const icon = hist?.status === 1 ? '✅' : hist?.status === 0 ? '⏳' : '';
                return (
                  <option key={v.id} value={v.id}>
                    {icon ? `${icon} ` : ''}{label} — {statusText}
                  </option>
                );
              })}
            </Form.Select>

            <div className="d-flex align-items-center gap-2 mt-2">
              {variantStatusBadge(selectedHist)}
            </div>

            {selectedVariant?.question && (
              <Card className="border-0 mt-3" style={{ background: 'rgba(79, 110, 247, 0.06)', borderRadius: '0.75rem' }}>
                <Card.Body className="p-3">
                  <div
                    className="text-muted"
                    style={{
                      fontSize: '0.82rem',
                      lineHeight: 1.5,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {selectedVariant.question.split('\n')[0]}
                  </div>
                </Card.Body>
              </Card>
            )}
          </Form.Group>

          <Button
            onClick={() => onSelect(selected)}
            disabled={selected === null}
            style={{
              background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
              border: 'none',
              borderRadius: '0.5rem',
              fontWeight: 600,
              fontSize: '1rem',
              padding: '0.75rem 2rem',
              width: '100%',
            }}
          >
            {startLabel}
          </Button>
        </Container>
      </div>
    </>
  );
}
